import { useState } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { PiX, PiMinus, PiCaretUpDownFill } from "react-icons/pi";
import { getRandomHexColor } from "../../snippets/utils/colors";
import { Task } from "../../tasks/models/Task";

export default function ViewOnlySnippet({ snippet }: { snippet: Task }) {
  const [showLineNumbers, setShowLineNumbers] = useState(true);
  const [showBackground, setShowBackground] = useState(true);
  const [hexColor, setHexColor] = useState<string>(
    snippet.hex ?? getRandomHexColor()
  );

  return (
    <div className="flex justify-center w-full mt-8">
      <div
        className={`${showBackground ? "py-8 md:p-8" : ""} resize-x
              } overflow-x-hidden overflow-y-hidden w-full `}
        style={{ backgroundColor: hexColor }}
        id="screenshot-container"
      >
        <div
          className={`bg-neutral w-full h-full  ${
            showBackground
              ? "rounded-none md:rounded-lg shadow-xl shadow-black/50"
              : "rounded-none"
          }`}
        >
          <div
            className={`w-32 h-12 pt-2 px-6 gap-2 flex flex-row items-center`}
          >
            <div
              title="Clear Snippet"
              className="rounded-full bg-neutral-content/30 hover:bg-red-500  hover:text-black/50 text-transparent border-none 
                  h-4 w-4 shadow-inner cursor-pointer place-content-center align-middle"
            >
              <center>
                <PiX size={12} />
              </center>
            </div>
            <div
              title="Remove Leading Spaces"
              className="rounded-full bg-neutral-content/30 hover:bg-yellow-500 hover:text-black/50 text-transparent border-none 
                  h-4 w-4 shadow-inner cursor-pointer place-content-center align-middle"
            >
              <center>
                <PiMinus size={12} />
              </center>
            </div>
            <div>
              <div
                title="Remove Leading Spaces"
                className="rounded-full bg-neutral-content/30 hover:bg-green-500 hover:text-black/50 text-transparent border-none 
                  h-4 w-4 shadow-inner cursor-pointer place-content-center align-middle"
                onClick={() => {
                  setShowBackground(!showBackground);
                }}
              >
                <center className="-rotate-45">
                  <PiCaretUpDownFill size={12} />
                </center>
              </div>
            </div>
          </div>
          <div className="w-full">
            <SyntaxHighlighter
              showLineNumbers={true}
              lineNumberStyle={{
                padding: "0 8px",
                width: "38px",
                color: showLineNumbers ? "" : "transparent",
              }}
              wrapLines
              //wrapLongLines
              language={snippet.language}
              style={atomOneDark}
              customStyle={{
                flex: "1",
                background: "transparent",
                borderRadius: "6px", // adjust this value as needed
                minHeight: "40px",
                scrollbarWidth: "none" /* For Firefox */,
                msOverflowStyle: "none" /* For Internet Explorer and Edge */,
                overflowX: "scroll",
                cursor: "text",
              }}
              lineProps={(lineNumber) => {
                return {
                  onClick: () => {
                    setShowLineNumbers((prev) => !prev);
                  },
                };
              }}
            >
              {snippet.snippet ?? ""}
            </SyntaxHighlighter>
          </div>
        </div>
      </div>
    </div>
  );
}
